<template>
	<div class="title-wrapper">
		<div class="title-avatar" v-if="timeline.avatar">
			<div class="image is-1-by-1">
				<img :src="timeline.avatar.url"/>
			</div>
		</div>
		<div class="title-container">
			<div class="title-content">
				<h1 class="title">
					{{ timeline.title}}
				</h1>
				<p>
					{{ timeline.description }}
				</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['timeline'],

		created() {

		}
	}
</script>

<style scoped>
	.title-wrapper {
		display: flex;
		flex-direction: row;
		flex-grow: 1;
		margin-left: 67px;
		margin-right: 67px;
	}

	.title-avatar {
		display: flex;
		flex: 1;
		align-items: center;
		justify-content: center;
	}

	.image img {
		border: 5px solid #fff;
		-webkit-box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.6);
		box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.6);
		max-width: 40vw;
		max-height: 40vh;
		width: inherit;
		height: inherit;
		background: #fff;
	}

	.title-container {
		display: flex;
		flex: 1;
		align-items: center;
		justify-content: center;
	}

	.title-content {
		text-align: left;
		padding-left: 25px;
		padding-right: 25px;
	}
</style>